// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Vvii","notes":"Notes_notes__d9q1h","note":"Notes_note__shc4i","markdown":"Notes_markdown__3g1Xw"};